// participant
export const PARTICIPANTS_QUERY_KEY = 'participants';
export const PARTICIPANT_QUERY_KEY = 'participant';
export const PARTICIPANT_COLUMNS_QUERY_KEY = 'participantColumns';
export const EXPORT_PARTICIPANT_LIST_QUERY_KEY = 'exportParticipantList';
export const GET_PARTICIPANT_TEMPLATE_QUERY_KEY = 'getParticipantTemplate';
export const GET_PARTICIPANT_LUCKYDRAW_TEMPLATE_QUERY_KEY = 'getParticipantLuckyDrawTemplate';
export const VALIDATE_PARTICIPANT_DATA_PATTERN_QUERY_KEY = 'validateParticipantDataPattern';

export const EVENT_QUERY_KEY = 'event';
export const EVENTS_QUERY_KEY = 'events';
export const EVENT_LOGS_QUERY_KEY = 'eventLogs';
export const EVENTS_LOGS_QUERY_KEY = 'eventsLogs';

export const EMAIL_TEMPLATES_QUERY_KEY = 'emailTempaltes';
export const EMAILS_QUERY_KEY = 'emails';
export const EMAIL_TEMPLATE_SETTING_QUERY_KEY = 'emailTemplateSetting';

export const SMSS_QUERY_KEY = 'smss';

export const TICKETS_QUERY_KEY = 'tickets';
export const TICKET_QUERY_KEY = 'ticket';

export const TICKET_TYPES_QUERY_KEY = 'ticketTypes';
export const TICKET_TYPE_QUERY_KEY = 'ticketType';
export const TICKET_TYPE_STATISTICS_QUERY_KEY = 'ticketTypeStatistics';

export const GUEST_TICKET_FOLDER_QUERY_KEY = 'guestTicketFolder';
export const GUEST_TICKET_QUERY_KEY = 'guestTicket';

export const SESSIONS_QUERY_KEY = 'sessions';

export const PAYMENT_SETTINGS_QUERY_KEY = 'paymentSettings';

export const MAILSERVER_SETTING_QUERY_KEY = 'mailServerSetting';
export const FAMILY_FORMS_QUERY_KEY = 'familyForms';

export const CACHE_QUERY_KEY = 'cache';

export const GUEST_SIGN_UP_QUERY_KEY = 'guestSignUp';
export const GUEST_SIGN_UP_FORM_QUERY_KEY = 'guestSignUpForm';
export const GUEST_SIGN_UP_RESULT_QUERY_KEY = 'guestSignUpResult';

export const BADGE_QUERY_KEY = 'badge';

export const SYSTEM_ANNOUNCEMENTS_QUERY_KEY = 'systemAnnouncements';

export const POINT_LOGS_QUERY_KEY = 'pointLogs';
export const POINT_QUERY_KEY = 'point';
export const CHECK_IN_QUOTA_QUERY_KEY = 'checkInQuota';
export const CHECK_IN_QUOTA_LOGS_QUERY_KEY = 'checkInQuotaLogs';

export const APP_VERSION_QUERY_KEY = 'appVersion';

export const SURVEY_FORMS_QUERY_KEY = 'surveyForm';
export const PREVIEW_GUEST_SURVEY_FORM_QUERY_KEY = 'previewGuestSurveyForm';
export const GUEST_SURVEY_FORM_QUERY_KEY = 'guestSurveyForm';
export const GUEST_SURVEY_FORM_PROJECT_CODE_FROM_UUID = 'guestSurveyFormProjectCodeFromUuid';
export const PRIZE_STYLING_QUERY_KEY = 'prizeStyling';

export const BOOTH_EVENT_QUERY_KEY = 'booth';

// ---------------------------MUTATION----------------------------------------
export const POST_PREPARE_CHECKIN_QR_CODE_IMAGE_KEY = 'postPrepareCheckinQrImage';
export const POST_PREPARE_INDEX_PAGE_QR_CODE_IMAGE_KEY = 'postPrepareIndexPageQrImage';

// ---------------------------Lucky Draw----------------------------------------
export const WINNER_LIST_QUERY_KEY = 'winnerList';
